import React, { Component } from 'react';
import { Carousel, Row, Col } from 'react-bootstrap';

/* import { UrlPublic } from '../../../shared/UrlPublic'; */

import img1 from '../../../assets/img/fondo1.png';
import pic1 from '../../../assets/img/image-003.jpg';
import logo from '../../../assets/img/logo-TAD-d.png';
/* import img2 from '../../../assets/img/home/home_2.jpg';
import img3 from '../../../assets/img/home/home_3.jpg';
import img4 from '../../../assets/img/home/home_4.jpg';
import img5 from '../../../assets/img/home/home_5.jpg';
 */
class Banner extends Component {
    state = {
        /* imagenes: [
            { id: 1, img: `${UrlPublic}img/home/home_1.jpg`, text: "Graduación Cohorte 2019" },
            { id: 2, img: `${UrlPublic}img/home/home_2.jpg`, text: "Publicidad y Mercadeo" },
            { id: 3, img: `${UrlPublic}img/home/home_3.jpg`, text: "Diseño Gráfico" },
            { id: 4, img: `${UrlPublic}img/home/home_4.jpg`, text: "Diseño de Moda" },
            { id: 5, img: `${UrlPublic}img/home/home_5.jpg`, text: "Diseño Interior" }
        ], */
        imagenes: [
            { id: 1, img: img1, text: "Graduación Cohorte 2019" }/* ,
            { id: 2, img: img2, text: "Publicidad y Mercadeo" },
            { id: 3, img: img3, text: "Diseño Gráfico" },
            { id: 4, img: img4, text: "Diseño de Moda" },
            { id: 5, img: img5, text: "Diseño Interior" } */
        ],
        blurT: 0,
        grayScaleT: 0,
        translateT: 0
    }

    /* componentDidMount() {    
        window.onscroll = () => this.handleAnimation();  
    }

    handleAnimation = () => {
        let scrollAct = window.scrollY;
        let scrollTot = document.body.scrollHeight - document.body.clientHeight;
        let porcentaje = (scrollAct * 100) / scrollTot;
        
        this.setState ({
            blurT: porcentaje / 5,
            grayScaleT: porcentaje * 4,
            translateT:  porcentaje / 3,
        })
    } */

    render() {
        return (
            <React.Fragment>
            <header className="header">
                <Carousel style={{zIndex: 0}} interval = {10000} controls = {false}>
                    {this.state.imagenes.map(option => (
                        <Carousel.Item className="carousel" key ={option.id}>
                            <div className="header-banner" style={{ backgroundImage:`url(${ option.img})`,/*  transform:`translateY(-${this.state.translateT}%)`, */ /* filter: `blur(${this.state.blurT}px) grayscale(${this.state.grayScaleT}%)` */}}>
                                <Row>
                                    <Col md={6} align = "center">
                                        <img src = {logo} alt = "logo_001" className="img img-responsive" height="auto" width="120px" style = {{marginTop: "18vh"}}/>
                                        <h1 style={{color:"white"}}>TEACHER AT DOOR</h1>
                                        <h3 style={{color:"white"}}><strong>Clases de Inglés personalizadas</strong></h3>
                                    </Col>
                                    <Col md={6} align = "center">
                                        <img src = {pic1} alt = "image_001" className="img img-thumbnail" height="auto" width="500px" style = {{marginTop: "25vh"}}/>
                                    </Col>
                                </Row>
                            </div>
                        </Carousel.Item>
                    ))}
                </Carousel>
            </header>
            </React.Fragment>
        );
    }
}

export default Banner;


// WEBPACK FOOTER //
// ./src/site/Componentes/Index/Banner.jsx